import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Privacypolicy=()=>{

return (<>
    <div className="home">
                <div id="page" className="hfeed page-wrapper">
                    
<Header/>
<div id="site-main" className="site-main">
  <div id="main-content" className="main-content">
    <div id="primary" className="content-area">
      {/* <div id="title" className="page-title">
        <div className="section-container">
          <div className="content-title-heading">
            <h1 className="text-title-heading">Refunds &amp; Returns</h1>
          </div>
          <div className="breadcrumbs">
            <a href="index.html">Home</a>
            <span className="delimiter" />
            Returns Policy
          </div>
        </div>
      </div> */}
      <br></br>
      <div id="content" className="site-content" role="main">
        <div className="page-contact">
          <section className="section section-padding">
            <div className="container">
              <h2>Website Policies </h2>
              <h4>Privacy Policy of Laxmi Diamond</h4>
              <p>
                This privacy policy discloses the privacy practices for
                LaxmiDiamond.com . This privacy policy applies solely to
                information collected by this web site. It will notify you of
                the following:
              </p>
              <li>
                What personally identifiable information is collected from you
                through the web site, how it is used and with whom it may be
                shared.
              </li>
              <li>
                What choices are available to you regarding the use of your
                data.
              </li>
              <li>
                The security procedures in place to protect the misuse of your
                information.
              </li>
              <li>How you can correct any inaccuracies in the information.</li>
              <h4>Information Collection, Use, and Sharing</h4>
              <p>
                Laxmi Diamond is the sole owners of the information collected on
                this site. West End only has access to/collect information that
                you voluntarily give us via email or other direct contact from
                you.
              </p>
              <p>
                We will use your information to respond to you, regarding the
                reason you contacted us. We will not share your information with
                any third party outside of our organization, other than as
                necessary to fulfill your request, e.g. to ship an order.
              </p>
              <p>
                Unless you ask us not to, we may contact you via email in the
                future to tell you about specials, new products or services, or
                changes to this privacy policy.
              </p>
              <p>(a) Information You Provide to Us:</p>
              <p>
                We receive and store any information you knowingly provide to
                us. For example, we may collect Personal Information including
                but not limited to your name, email address, location, IP
                address, and other browser cookie information. We may collect
                other Personal Information you provide us through your use of
                our services.
              </p>
              <p>(b) Information Collected Automatically:</p>
              <p>
                Whenever you interact with our Website, we automatically receive
                and record information on our server logs from your browser
                including your IP address, “cookie” information, potential email
                information, and the page you requested.
              </p>
              <p>
                “Cookies” are identifiers we transfer to your computer through
                your browser that allow us to recognize your browser and tell us
                how and when pages in our site are visited and by how many
                people. You may be able to change the preferences on your
                browser to prevent or limit your computer’s acceptance of
                cookies, but this may prevent you from taking advantage of our
                Website’s best features. Our advertising partners may also
                transmit cookies to your computer, when you click on ads that
                appear on our site. This Privacy Policy does not cover the use
                of cookies by any advertisers.
              </p>
              <p>(c) E-mail and Other Communications:</p>
              <p>
                We may contact you by email or other means; for example, we may
                send you promotional offers on behalf of other businesses, or
                communicate with you about your use of the Website. Also, we may
                receive a confirmation when you open an email from us. This
                confirmation helps us make emails more interesting and improve
                our service.
              </p>
              <p>(d) Additional Information:</p>
              <p>
                We may collect and store information that your computer or
                mobile device provides to us in connection with your use of the
                Website, such as the type of computer or mobile device, unique
                device ID, IP address, MAC address, device’s operating system
                and physical location (including geographic, beacon based,
                and/or GPS location).
              </p>
              <h2>Your Access to and Control over Information</h2>
              <p>
                You may opt out of any future contacts from us at any time. You
                can do the following at any time by contacting us via the email
                address or phone number given on our website:
              </p>
              <li>See what data we have about you, if any.</li>
              <li> Change/correct any data we have about you.</li>
              <li>Have us delete any data we have about you.</li>
              <li>Express any concern you have about our use of your data.</li>
              <h2>Registration</h2>
              <p>
                In order to use the westend.com website, a user must first
                complete the registration form. During registration a user is
                required to give certain information (such as name and email
                address). This information is used to contact you about the
                products/services on our site in which you have expressed
                interest. At your option, you may also provide demographic
                information (such as gender or age) about yourself, but it is
                not required.
              </p>
              <h2>Orders</h2>
              <p>
                westend.com requests information from you on our order form. To
                buy from us, you must provide contact information (like name and
                shipping address) and financial information (like credit card
                number, expiration date). This information is used for billing
                purposes and to fill your orders. If we have trouble processing
                an order, we'll use this information to contact you.
              </p>
              <h2>Cookies</h2>
              <p>
                westend.com uses "cookies" on this site. A cookie is a piece of
                data stored on a site visitor's hard drive to help us improve
                your access to our site and identify repeat visitors to our
                site. For instance, when we use a cookie to identify you, you
                would not have to log in a password more than once, thereby
                saving time while on our site. Cookies can also enable us to
                track and target the interests of our users to enhance the
                experience on our site. Usage of a cookie is in no way linked to
                any personally identifiable information on our site. When you
                visit or log in to our website, cookies and similar technologies
                may be used by our online data partners or vendors to associate
                these activities with other personal information they or others
                have about you, including by association with your email or home
                address. We (or service providers on our behalf) may then send
                communications and marketing to these email or home addresses.
                You may opt out of receiving this advertising by clicking here.
              </p>
              <h2>Security</h2>
              <p>
                We take precautions to protect your information. When you submit
                sensitive information via the website, your information is
                protected both online and offline. Wherever we collect sensitive
                information (such as credit card data), that information is
                encrypted and transmitted to us in a secure way. You can verify
                this by looking for a closed lock icon at the bottom of your web
                browser, or looking for "https" at the beginning of the address
                of the web page. While we use encryption to protect sensitive
                information transmitted online, we also protect your information
                offline. Only employees who need the information to perform a
                specific job (for example, billing or customer service) are
                granted access to personally identifiable information. The
                computers/servers in which we store personally identifiable
                information are kept in a secure environment.
              </p>
              <h2>Updates</h2>
              <p>
                Our Privacy Policy may change from time to time and all updates
                will be posted on this page. If you feel that we are not abiding
                by this privacy policy, you should contact us immediately via
                telephone at 1-212-519-1420 or via email westend@gmail.com.
              </p>
              <h2>Shipping Policy</h2>
              <p>Shipping &amp; Handling Charges (S&amp;H)</p>
              <p>
                Shipping &amp; Handling Charges is the charge for ecommerce
                order processing, packaging, transportation, and handling.
                Shipments and deliveries occur only on business days. Items
                ordered together may not always ship together. If your order
                requires more than one shipment, you will only be charged one
                shipping fee. Delivery times are not guaranteed.We are unable
                ship to post office boxes. Delivery &amp; Processing is subject
                to change and will be determined at time of order and subject to
                the following:
              </p>
              <h2>
                UPS Next Day Air - Free Shipping and Handling (Domestic Only)
              </h2>
              <p>
                Your order should arrive next business day after shipping if
                ordered by 3:00pm (ET). Please note that orders placed after
                3:00PM (EST) Friday, Saturday, or Sunday will be processed
                Monday and should arrive the next business day after shipping.
                Saturday, Sunday and holiday delivery is not available. A
                signature will be required for all shipments.
              </p>
              <p>
                FedEx International Priority (outside of US) - Please note the
                purchaser is responsible for all duties and taxes applied to any
                shipment outside the US. This amount will be added at checkout.
              </p>
              <p>
                Your order should arrive 3 to 5 business days after shipping if
                ordered by 3:00PM (EST). Please note that international orders
                placed after 3:00PM (EST) Friday, Saturday, or Sunday will be
                processed Monday and should arrive 3 to 5 business days after
                shipping. A signature will be required for all shipments.
                Saturday, Sunday and holiday delivery is not available.
              </p>
              <p>
                Complimentary shipping is only available for orders placed on
                the U.S. Website for domestic delivery.
              </p>
            </div>
          </section>
          <section className="section section-padding m-b-70">
            <div className="section-container">
              {/* Block Contact Info */}
              <div className="block block-contact-info">
                <div className="block-widget-wrap">
                  <div className="info-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Capa_1"
                      height={512}
                      viewBox="0 0 511.985 511.985"
                      width={512}
                    >
                      <g>
                        <g>
                          <path d="m256.002 19.995c-4.193 0-8.038-2.714-9.438-6.667-1.415-3.996-.091-8.565 3.231-11.192 3.218-2.545 7.81-2.846 11.333-.741 3.587 2.144 5.493 6.408 4.697 10.512-.902 4.643-5.097 8.088-9.823 8.088z" />
                          <path d="m486.898 258.449c12.552-6.567 20.748-20.113 19.768-35.14-.641-9.838-5.073-18.839-12.478-25.343-4.91-4.312-10.737-7.185-16.974-8.444-14.109-91.307-83.346-165.063-174.016-184.544-5.399-1.16-10.723 2.277-11.883 7.68-1.162 5.402 2.278 10.723 7.68 11.884 82.042 17.628 144.813 84.063 158.199 166.49-14.984 5.483-25.248 20.366-24.158 37.083.64 9.831 5.066 18.824 12.46 25.326-8.551 4.454-14.918 11.927-17.963 21.102-3.64 10.962-1.835 22.447 3.935 31.503-1.269-.047-2.548-.03-3.833.054-9.835.642-18.83 5.079-25.331 12.493-7.141 8.146-10.047 18.579-8.897 28.58-.57-.221-1.148-.429-1.732-.623-9.356-3.111-19.359-2.388-28.169 2.032-8.947 4.489-15.278 12.151-18.315 20.944l-81.746-89.114-.161-.16c-4.044-4.041-10.602-4.025-14.626.035l-.032.032c-.002.002-81.832 89.207-81.832 89.207-3.037-8.793-9.368-16.455-18.315-20.944-8.81-4.42-18.817-5.144-28.169-2.032-.584.194-1.162.402-1.732.623 1.15-10.002-1.756-20.435-8.897-28.581-6.501-7.413-15.496-11.85-25.331-12.492-1.284-.085-2.563-.103-3.831-.056 5.769-9.056 7.574-20.539 3.935-31.5-3.046-9.176-9.413-16.649-17.964-21.103 7.394-6.502 11.819-15.495 12.46-25.326 1.09-16.717-9.173-31.6-24.157-37.083 13.363-82.19 76.353-148.774 157.896-166.426 5.366-1.162 9.066-6.345 8.026-11.735-1.066-5.526-6.455-9.066-11.928-7.893-90.28 19.398-159.919 93.388-174.016 184.542-6.234 1.26-12.064 4.135-16.973 8.446-7.405 6.504-11.838 15.504-12.479 25.343-.98 15.028 7.216 28.573 19.768 35.14-10.777 9.503-15.465 24.89-10.66 39.366 3.107 9.358 9.668 16.946 18.478 21.365 5.21 2.614 10.837 3.935 16.5 3.935.477 0 .955-.01 1.433-.028-8.588 13.487-7.683 31.584 3.374 44.198 6.501 7.413 15.496 11.85 25.331 12.492.822.054 1.64.08 2.455.08 4.598 0 9.089-.848 13.29-2.48-1.698 14.954 5.912 30.08 20.119 37.209 5.21 2.614 10.836 3.934 16.499 3.934 3.914 0 7.847-.631 11.67-1.902 4.973-1.653 9.445-4.285 13.207-7.712l91.792 100.065c.005.005.018.019.04.04 4.089 3.962 10.592 3.958 14.72.036l.03-.029 91.836-100.113c3.762 3.427 8.234 6.058 13.207 7.712 3.824 1.271 7.755 1.902 11.67 1.902 5.662 0 11.289-1.32 16.499-3.934 14.206-7.128 21.817-22.255 20.119-37.209 4.201 1.632 8.691 2.48 13.29 2.48.815 0 1.634-.026 2.455-.08 9.835-.642 18.83-5.079 25.331-12.493 11.057-12.613 11.962-30.709 3.375-44.197.477.019.955.028 1.432.028 5.662 0 11.29-1.321 16.5-3.935 8.809-4.419 15.371-12.007 18.478-21.365 4.806-14.475.117-29.862-10.659-39.365zm-18.146-49.608c4.491-.292 8.841 1.184 12.229 4.16 3.391 2.979 5.422 7.101 5.716 11.61.607 9.302-6.459 17.364-15.749 17.971-4.492.296-8.841-1.183-12.23-4.159-3.391-2.978-5.421-7.101-5.715-11.609-.606-9.303 6.459-17.366 15.749-17.973zm-212.76 224.088-32.196-38.257 32.196-38.257 32.195 38.257zm10.006-95.702v-24.429l65.927 71.869h-26.004zm-20.011-24.429v24.429l-39.924 47.44h-26.003zm-220.7-88.188c.294-4.507 2.324-8.63 5.716-11.609 3.106-2.728 7.014-4.197 11.109-4.197.371 0 .746.012 1.121.036 9.29.607 16.355 8.67 15.749 17.973-.294 4.507-2.324 8.631-5.715 11.609-3.389 2.974-7.728 4.445-12.23 4.159-9.291-.606-16.357-8.668-15.75-17.971zm16.591 76.684c-4.032-2.023-7.036-5.497-8.459-9.783-2.937-8.849 1.863-18.438 10.7-21.377 1.749-.581 3.547-.87 5.337-.87 2.59 0 5.163.604 7.546 1.8 4.031 2.023 7.036 5.496 8.459 9.783 2.937 8.849-1.863 18.438-10.701 21.377-4.278 1.422-8.854 1.093-12.882-.93zm51.2 54.354c-3.389 2.977-7.74 4.454-12.23 4.16-4.499-.294-8.614-2.324-11.588-5.716-6.145-7.01-5.447-17.715 1.557-23.864 3.105-2.728 7.013-4.197 11.107-4.197.373 0 .747.012 1.123.036 4.499.294 8.614 2.324 11.588 5.716 6.142 7.011 5.445 17.717-1.557 23.865zm44.184 41.98c-4.28 1.422-8.854 1.093-12.882-.929-8.327-4.177-11.704-14.358-7.528-22.695 2.022-4.035 5.491-7.042 9.77-8.465 1.749-.581 3.546-.87 5.336-.87 2.59 0 5.164.604 7.547 1.8 8.326 4.177 11.704 14.357 7.528 22.694-2.021 4.036-5.492 7.042-9.771 8.465zm68.801 7.05 39.924 47.44v24.429l-65.927-71.869zm59.935 71.869v-24.429l39.923-47.44h26.004zm121.606-79.848c-4.029 2.023-8.604 2.352-12.882.929-4.279-1.423-7.749-4.429-9.771-8.465-4.175-8.337-.797-18.517 7.528-22.694 4.03-2.022 8.604-2.354 12.883-.93 4.279 1.423 7.748 4.429 9.77 8.465 4.176 8.337.799 18.518-7.528 22.695zm55.122-42.607c-2.974 3.392-7.09 5.423-11.588 5.717-4.488.293-8.841-1.183-12.229-4.16-.001 0-.001 0-.001 0-7.003-6.149-7.699-16.855-1.556-23.863 2.974-3.392 7.09-5.423 11.588-5.717.375-.024.749-.036 1.123-.036 4.094 0 8.001 1.469 11.108 4.197 7.002 6.148 7.699 16.853 1.555 23.862zm35.839-62.581c-1.423 4.286-4.426 7.76-8.459 9.783-4.03 2.023-8.604 2.353-12.882.93-8.838-2.939-13.638-12.528-10.7-21.378 1.422-4.285 4.426-7.759 8.458-9.782 4.03-2.023 8.604-2.353 12.882-.93 8.838 2.94 13.638 12.529 10.701 21.377z" />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="info-title">
                    <h2>Talk to our Jewellery Experts</h2>
                  </div>
                  <div className="info-items">
                    <div className="row">
                      <div className="col-md-4 sm-m-b-30">
                        <div className="info-item">
                          <div className="item-tilte">
                            <h2>Phone</h2>
                          </div>
                          <div className="item-content">810.222.5439</div>
                        </div>
                      </div>
                      <div className="col-md-4 sm-m-b-30">
                        <div className="info-item">
                          <div className="item-tilte">
                            <h2>Customer Service</h2>
                          </div>
                          <div className="item-content">
                            <p>Monday to Friday</p>
                            <p>8:00am – 4:00pm Sydney, NSW time (UTC +10)</p>
                            <p>Saturday and Sunday closed</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="info-item">
                          <div className="item-tilte">
                            <h2>Returns</h2>
                          </div>
                          <div className="item-content small-width">
                            For information on Returns and Refunds, please click{" "}
                            <a href="#">here.</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* #content */}
    </div>
    {/* #primary */}
  </div>
  {/* #main-content */}
</div>

<Footer/>
</div>

</div>

</>)




}

export default Privacypolicy;